import { render } from "./ViewGrid.vue?vue&type=template&id=672ea5c8"
import script from "./ViewGrid.vue?vue&type=script&lang=js"
export * from "./ViewGrid.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__